module.exports = __webpack_public_path__ + "static/img/taskCancel.d9a9222.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/imageSaver/taskCancel.svg
// module id = iW+c
// module chunks = 2